import type { TBlueObj } from "@app/types/insider";

export type TContractorsEditing = {
  mainCffId: number;
  searchCIF: string;
  emitentID: number;
};

export const uiContractorsEditing: TBlueObj<TContractorsEditing> = {
  name: "uiContractorsEditing",
  initialState: {
    mainCffId: -1,
    searchCIF: "",
    emitentID: -1,
  },
  starfx: true,
  idb: false,
  bootPriority: 1,
};
